import React from 'react';
import Placeholder from '@atlaskit/react-ufo/placeholder';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import { HorizontalNavSkeleton } from '@atlassian/jira-horizontal-nav-common/src/ui/horizontal-nav-skeleton/index.tsx';
import { customPracticeQueueRoute } from '@atlassian/jira-router-routes-servicedesk-queue-routes/src/customPracticeQueueRoute.tsx';
import { useCurrentRoute } from '@atlassian/jira-platform-router-utils/src/index.tsx';
import { usePathParam } from '@atlassian/react-resource-router';
import type HorizontalNavQueue from './ui/HorizontalNavQueue.tsx';

const LazyHorizontalNavQueue = lazyForPaint<typeof HorizontalNavQueue>(() =>
	import(/* webpackChunkName: "async-horizontal-nav-queue" */ './ui/HorizontalNavQueue').then(
		(HorizontalNavQueue) => HorizontalNavQueue,
	),
);

export const AsyncHorizontalNavQueue = () => {
	const route = useCurrentRoute();
	const [issueKey] = usePathParam('issueKey');

	// Practice qeueue contains both Queue and Issue view.
	// We don't want to render the horizontal nav for issue view.
	if (route.name === customPracticeQueueRoute.name && issueKey) {
		return null;
	}

	return (
		<Placeholder name="horizontal-nav-queue" fallback={<HorizontalNavSkeleton />}>
			<LazyHorizontalNavQueue />
		</Placeholder>
	);
};
